import React from "react";

const SkillsMobile = () => {
  return (
    <div className="bg-gray-100 p-4">
      <h1 className="font-bold text-skillsHeading text-2xl">
        Tech-stack for Our Website Development Firm
      </h1>
      <p className="py-6 text-sm text-gray-700">
        As an experienced website development firm, we understand the
        significance of the latest technologies to give a competitive edge to
        clients in the market. We deploy evolving technologies to build
        innovative web solutions ensuring rich feature-based functionalities.
      </p>
      <h2 className="font-bold text-lg text-skillsHeading">
        PERN Stack Development
      </h2>
      <ul className="px-4 text-sm list-disc my-2">
        <li>React.js</li>
        <li>PostgreSQL</li>
        <li>Express.jst</li>
        <li>Node.js</li>
        <li>Typescript</li>
        <li>Next.js</li>
      </ul>
      <h2 className="font-bold text-lg text-skillsHeading">
        JAM Stack Development
      </h2>
      <ul className="px-4 text-sm list-disc my-2">
        <li>Next.js</li>
        <li>Gatsby.js</li>
        <li>GraphQL</li>
        <li>FaunaDB</li>
        <li>Contentful CMS</li>
        <li>Sanity CMS</li>
        <li>Strapi CMS</li>
        <li>Ghost CMS</li>
        <li>Typescript</li>
        <li>Serverless Functions</li>
        <li>Firebase</li>
      </ul>
      <h2 className="font-bold text-lg text-skillsHeading">
        Frontend Development
      </h2>
      <ul className="px-4 text-sm list-disc my-2">
        <li>HTML</li>
        <li>CSS</li>
        <li>Sass</li>
        <li>ReactJs</li>
        <li>GatsbyJs</li>
        <li>NextJs</li>
        <li>Tailwind-css</li>
        <li>Material-UI</li>
        <li>Bootstrap</li>
        <li>Firebase</li>
        <li>Vite</li>
        <li>Figma</li>
        <li>Canva</li>
      </ul>
      <h2 className="font-bold text-lg text-skillsHeading">
        MERN Stack Development
      </h2>
      <ul className="px-4 text-sm list-disc my-2">
        <li>MongoDB</li>
        <li>Express.js</li>
        <li>React.js</li>
        <li>Node.js</li>
        <li>Typescript</li>
        <li>Next.js</li>
        <li>Stripe</li>
        <li>REST APIs</li>
      </ul>
      <h2 className="font-bold text-lg text-skillsHeading">
        Web 3.0 DApp Development
      </h2>
      <ul className="px-4 text-sm list-disc my-2 mb-6">
        <li>React.js</li>
        <li>Web3.js</li>
        <li>Ethers.js</li>
        <li>Solidity</li>
        <li>Smart Contract</li>
        <li>Hardhat</li>
        <li>Waffle</li>
        <li>Metamask Wallet</li>
      </ul>
      <h2 className="font-bold text-lg text-skillsHeading">
        Excel to Web Conversion
      </h2>
      <ul className="px-4 text-sm list-disc my-2 mb-6">
        <li>Excel</li>
        <li>HTML</li>
        <li>CSS</li>
        <li>Javascript</li>
        <li>Typescript</li>
        <li>Charts</li>
        <li>React-Table</li>
        <li>Chart.js</li>
        <li>Plotly</li>
        <li>React-Admin</li>
      </ul>
      <h2 className="font-bold text-lg text-skillsHeading">
        Web 3.0 NFT Listing
      </h2>
      <ul className="px-4 text-sm list-disc my-2 mb-6">
        <li>React.js</li>
        <li>Next.js</li>
        <li>Typescript</li>
        <li>Opensea API</li>
        <li>NFT-listing</li>
        <li>Minting</li>
        <li>Thirdweb</li>
      </ul>
      <h2 className="font-bold text-lg text-skillsHeading">
        OpenAI Integration
      </h2>
      <ul className="px-4 text-sm list-disc my-2 mb-6">
        <li>ChatGPT Integration</li>
        <li>OpenAI API Integration</li>
      </ul>
      <h2 className="font-bold text-lg text-skillsHeading">
        Ecommerce Development
      </h2>
      <ul className="px-4 text-sm list-disc my-2 mb-6">
        <li>React-Admin</li>
        <li>React.js</li>
        <li>Next.js</li>
        <li>Gatsby.js</li>
        <li>Typescript</li>
        <li>Stripe</li>
        <li>CMS</li>
      </ul>
    </div>
  );
};

export default SkillsMobile;
